var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{staticClass:"textbox",style:(_vm.textareaStyle),attrs:{"placeholder":_vm.placeholder,"maxlength":_vm.maxChars},domProps:{"value":_vm.value},on:{"input":_vm.emit,"blur":_vm.blur}})}
var staticRenderFns = []

export { render, staticRenderFns }